import styled from 'styled-components';

export const FareBreakUpTipOuterWrap = styled.div(
  props => `
      width: 27.5rem;
      background-color: ${props.theme.colors.black.base};
      display: flex;
      flex-direction: column;
      position: absolute;
      top: 2.2rem;
      right:0;
      opacity: 0;
      border-radius: 6px;
      z-index:2;
      &:after{
          content: '';
          position: absolute;
          top:-1rem;
          right: 1.5rem;
          border-left: 10px solid transparent;
          border-right: 10px solid transparent;
          border-bottom: 10px solid ${props.theme.colors.black.base};
      }
  `
);

export const FareBreakUpInnerWrap = styled.div(
  props => `
      width:100%;
      display: flex;
      flex-direction: column;
  `
);

export const BreakupText = styled.p(
  props => `
      font-size: ${props.theme.font.base};
      color: ${props.theme.colors.white.base};
      font-weight: ${props.theme.font.fontWeight.bold};
      span{
          color: ${props.theme.colors.green.dark};
      }
  `
);

export const BreakupPrice = styled.p(
  props => `
      font-size: ${props.theme.font.large.font14};
      color: ${props.theme.colors.white.base};
      font-weight: ${props.theme.font.fontWeight.bold};
      text-align: right;
  `
);

export const TotalPriceWrap = styled.div(
  props => `
      width:100%;
      dispaly: flex;
      flex-direction: column;
      padding: ${props.theme.spacing.base};
  `
);

export const TotalPriceInfoWrap = styled.div(
  props => `
      width:100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
  `
);

export const TotalPriceText = styled.p(
  props => `
      font-size: ${props.theme.font.large.font14};
      color: ${props.theme.colors.white.base};
      font-weight: ${props.theme.font.fontWeight.bold};
  `
);

export const OfferBreakupWrap = styled.div(
  props => `
      width:100%;
      display: flex;
      flex-direction: column;
      background-color: #343434;
      border-radius: 4px;
      margin-top: ${props.theme.spacing.base};
      padding: ${props.theme.spacing.base} ${props.theme.spacing.base} ${props.theme.spacing.small.s5}; 
  `
);

export const OfferBreakupInnerWrap = styled.div(
  props => `
      width:100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-bottom: ${props.theme.spacing.small.s5};
  `
);
